import {
  Box,
  Button,
  Grid,
  styled,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';

export const TableBodyContainer = styled(TableContainer)(
  ({ $bodyBackgroundColor, $noBorder }) => ({
    flex: 1,
    overflowY: 'auto',
    border: $noBorder ? 'none' : `2px solid rgba(0, 0, 0, 0.12)`,
    borderRadius: '12px',
    boxShadow: 'none',
    ...($bodyBackgroundColor && { backgroundColor: $bodyBackgroundColor }),
  }),
);

export const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '16px',
  backgroundColor: theme.palette.grey[100],
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const StyledTableCell = styled(TableCell)({
  padding: '0px',
});

export const StyledLocationSortButton = styled(Button)({
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '15px',
  fontWeight: 500,
});

export const TableInfoContainer = styled(Grid)({
  padding: '0 0 10px 0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});
export const TableInfoBottomContainer = styled(Grid)({
  padding: '10px 0 10px 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#F5F8FD',
  margin: '10px 0 10px 0',
});
export const TableInfoBottomContainerItem = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const TableCellNameText = styled('span')<{ $width: number }>(
  ({ $width }) => ({
    ...($width && { maxWidth: `${$width}px` }),
    width: `fit-content`,
  }),
);

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop: string) => prop !== 'selected',
})<{
  selected?: boolean;
}>(
  ({ theme, selected }) => `
  cursor: pointer;
  background-color: ${selected ? 'rgba(2, 90, 197, 0.08)' : 'transparent'};
  transition: background-color 0.2s ease;

  td {
    border-bottom: 1px solid ${theme.palette.divider};
  }

  &:hover {
    background-color: ${
      selected ? 'rgba(2, 90, 197, 0.08)' : theme.palette.action.hover
    };
  }
`,
);

export const FlexTableWrapper = styled(Box)(
  ({ $height }) =>
    `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  height: ${$height ?? '100%'};
  width: 100%;
  min-height: 0;
`,
);
